import React from "react";
import SEO from "../components/SEO";
import PageTitle from "../components/PageTitle";
import Breadcrumb from "../components/Breadcrumb";

const Terms = () => {
  return (
    <>
      <SEO
        title="Şartlar & Koşullar | WiaSoft"
        description="WiaSoft web sitesi kullanım şartları ve koşulları"
        type="website"
      />
      <PageTitle title="Şartlar & Koşullar" />
      <Breadcrumb title="Şartlar & Koşullar" />
      
      <section className="services-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="service-content">
                <h2>Şartlar & Koşullar</h2>
                
                <h3>1. Hizmet Kapsamı</h3>
                <p>
                  WiaSoft tarafından sunulan tüm hizmetler ve içerik, bu şartlar ve koşullar çerçevesinde 
                  sağlanmaktadır. Sitemizi kullanarak bu şartları kabul etmiş sayılırsınız.
                </p>

                <h3>2. Fikri Mülkiyet Hakları</h3>
                <p>
                  Sitemizde yer alan tüm içerik, tasarım, metin, grafikler, resimler ve logolar WiaSoft'un 
                  veya ilgili haklar sahibinin fikri mülkiyetidir. Bu içeriklerin izinsiz olarak 
                  kullanılması, kopyalanması veya dağıtılması yasaktır.
                </p>

                <h3>3. Sorumluluk Sınırlaması</h3>
                <p>
                  WiaSoft, sitede yer alan bilgilerin doğruluğu, eksiksizliği veya hatasızlığı konusunda 
                  hiçbir garanti vermez. Sitede yer alan bilgilerin kullanımından doğacak tüm sorumluluk 
                  kullanıcıya aittir.
                </p>

                <h3>4. Harici Bağlantılar</h3>
                <p>
                  Sitemizde yer alan harici bağlantılar hakkında sorumluluk taşımamız. Bu bağlantılar 
                  kullanıcının kendi sorumluluğunda açılmaktadır.
                </p>

                <h3>5. Değişiklikler</h3>
                <p>
                  WiaSoft, bu şartları ve koşulları herhangi bir ön bildirim olmaksızın değiştirebilir. 
                  Düzenli olarak bu sayfayı kontrol etmeniz önerilir.
                </p>

                <h3>6. İletişim</h3>
                <p>
                  Bu şartlar ve koşullar hakkında sorularınız varsa, lütfen bizimle iletişime geçiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
